import { makeStyles, tokens } from '@fluentui/react-components';
export var useVisualBackgroundStyles = makeStyles({
    pageBackgroundCommonClass: {
        position: 'absolute',
        width: '100%',
        height: 'clamp(460px, 50vw, 720px)',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        'background-position': 'center top',
    },
    pageBackgroundImageDiv: {
        backgroundColor: tokens.colorNeutralBackground2,
    },
    pageTransitionBefore: {
        opacity: 0,
        transform: 'scale(1.05)',
        transitionProperty: 'transform, opacity',
        transitionDuration: '1s',
        transitionTimingFunction: 'cubic-bezier(.5,0,.23,.99), linear',
    },
    pageHomepageTransitionAfter: {
        opacity: 1,
        transform: 'scale(1)',
    },
    pageBackgroundGradientDiv: {
        backgroundColor: 'transparent',
        filter: 'blur(15px)',
        transform: 'scale(1.13)',
    },
    pageCreateMyContentAppsModuleTransitionAfter: {
        filter: 'blur(2px)',
        opacity: 0.16,
        transform: 'scale(1)',
    },
    orangeOpacity: {
        opacity: 0.16,
    },
    m365Opacity: {
        opacity: 0.32,
    },
});
//# sourceMappingURL=VisualBackgroundControl.styles.js.map